import React from 'react'
import { withRouter, Link } from 'react-router-dom';
import { withFirebase } from '../firebase';
import appLogo from '../../images/logo.png'
import '../styles/login.css';
import Loader from 'react-loader-spinner';
import ModalInfo from '../useful/ModalInfo';

const INITIAL_STATE = {
    loading: false,
    email: '',
    modal: {
        show: false,
        title: '',
        message: ''
    },
    modalSuccess: {
        show: false,
        title: '',
        message: ''
    }
};

// Modal.setAppElement('#root');
class PasswordReset extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSignIn = (e) => {
        e.preventDefault();

        const { email } = this.state;
        const isInvalid = email === '';

        if (!isInvalid) {
            this.setState({ loading: true });

            this.props.firebase
                .doPasswordReset(email)
                .then(() => {
                    this.showSuccessModal("Correo enviado", "Siga las intruciones del correo que le hemos enviado para recuperar su contraseña.");
                })
                .catch(error => {
                    this.setState({ loading: false });
                    this.showErrorModal("El correo introducido es incorrecto");
                    console.log("Error: ", error);
                });
        } else {
            this.showErrorModal("El correo introducido es incorrecto");
        }
    }

    showSuccessModal = (title, message) => {
        this.setState({
            modalSuccess: {
                show: true,
                title: title,
                message: message
            }
        });
    }
    closeSuccessModal = () => {
        this.setState({
            modalSuccess: {
                show: false,
                title: '',
                message: ''
            }
        });
        this.props.history.push("/login");
    }

    showErrorModal = (message) => {
        this.setState({
            modal: {
                show: true,
                title: 'Error',
                message: message
            }
        });
    }

    closeModal = () => {
        this.setState({
            modal: {
                show: false,
                title: '',
                message: ''
            }
        });
    }

    render() {
        const { loading, email, modal, modalSuccess } = this.state;
        const isInvalid = email === '';

        return (
            <div className="mt-4 row justify-content-center align-items-center" >

                <form className="form-signin text-center" onSubmit={this.handleSignIn}>
                    <img className="mb-4" src={appLogo} alt="" height="72" />
                    <h4 className="mb-3 font-weight-normal">Recuperar Contraseña</h4>

                    <div className="form-group text-left">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="email">Correo electrónico:</label>
                        <input onChange={this.handleChange} className="form-control"
                            type="text" id="email" name="email" placeholder="example@mail.com" required="" />
                    </div>

                    {/* <input onChange={this.handleChange} name="email" type="email" className="form-control" placeholder="Email" required="" /> */}

                    {(!loading) ?
                        <>
                            <button disabled={isInvalid} className="mt-3 btn btn-lg btn-app btn-block" type="submit">Enviar</button>
                            <br />
                            <Link to="/login" className="mt-2 ">
                                Iniciar Sesión!!
                            </Link>
                        </>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                    <p className="mt-5 mb-3 text-muted">©fairplay-2020</p>
                </form>

                <ModalInfo
                    data={modal}
                    onClose={this.closeModal}
                />

                <ModalInfo
                    data={modalSuccess}
                    onClose={this.closeSuccessModal}
                />

            </div>
        );
    }
}


export default withRouter(withFirebase(PasswordReset));